<!--
 * @Description:订单详情
 * @Author: guqiang
 * @Date: 2021-10-18 15:58:17
 * @LastEditors: guqiang
 * @LastEditTime: 2021-11-02 17:32:52
-->

<template lang="pug">
    div.order-detail(
        v-loading="loading"
        element-loading-text="玩命加载中"
    )
        header-title(title="",backRouteName="OrderManageIndex")
            div(
                slot="remark-desc"
                class="order-detail-tab"
            )
                count-tabs(
                    v-model="activeName"
                    :showCount="false"
                    :isDetail="true"
                    :options="tabOptions"
                )
        .infos(v-show="activeName === 'detail'")
            div(:class="status")
                .info-status 当前订单状态：
                    span.status-desc {{ statusDesc}}
                .times
                    span.time 创建时间：{{orderDetail.createTime | dateFormat}}
                    span.time 支付时间：{{orderDetail.paymentTime | dateFormat}}
                    span.time 完成时间：{{orderDetail.closingTime | dateFormat}}
            .info-base.info
                .info-header 基本信息
                .info-table
                    el-table(:data="baseTableData",border)
                        el-table-column(align="center",prop="orderNo",label="订单编号")
                        el-table-column(align="center",prop="nickPhone",label="用户账号")
                        el-table-column(align="center",prop="vin",label="车架号" v-if="orderDetail.goodsType === 'SERVICE_PACK'")
                        el-table-column(align="center",prop="paymentWay",label="支付方式")
                        el-table-column(align="center",prop="appType",label="订单来源")
                        el-table-column(align="center",prop="orderType",label="订单类型")
                        el-table-column(align="center",prop="deliveryWay",label="发货方式")
            .info-goods.info
                .info-header 商品信息
                .info-table
                    el-table(:data="gooodsTableData",border)
                        el-table-column(align="center",prop="name",label="商品图片")
                            template(slot-scope="scope")
                                .img-contaner(v-if='scope.row.picUrl')
                                    img.pic-main(:src="`${oss.PUBLIC.token.cdnHost}${scope.row.picUrl}`")
                                span(v-else) 合计
                        el-table-column(align="center",prop="spuName",label="商品信息")
                            template(slot-scope="scope")
                                .spu-id {{ scope.row.spuId }}
                                .name {{ scope.row.spuName }}
                        el-table-column(align="center",prop="goodsType",label="商品类型")
                            template(slot-scope="scope")
                                div {{ scope.row.goodsType ? goodsTypeObj[scope.row.goodsType] : (scope.row.picUrl ? '--' : '') }}
                        el-table-column(align="center",prop="skuId",label="SKU编号")
                        el-table-column(align="center",prop="specInfo",label="商品规格")
                            template(slot-scope="scope")
                                span {{  scope.row.skuId ? scope.row.specInfo ||  '--' : (scope.row.picUrl ? '--' : '')  }}
                        el-table-column(align="center",prop="quantity",label="数量")
                        el-table-column(align="center",prop="salesPrice",label="售价(元)")
                        el-table-column(align="right",prop="total",label="小计(元)")
            .pay-info.info
                .info-header 费用信息
                .info-table
                    el-table(:data="payTableData",border)
                        el-table-column(align="center",prop="salesPrice",label="商品合计(元)")
                        el-table-column(v-if="isPhysicalMail" align="center",prop="freightPrice",label="运费(元)")
                        el-table-column(align="center",prop="totalAmount",label="订单总金额(元)")
                        el-table-column(align="center",prop="discount",label="优惠明细(元)",width="210")
                            template(slot-scope="scope")
                                div(v-if="scope.row.discount && scope.row.discount.length")
                                    div(v-for="(item, index) in scope.row.discount" :key="index" style="display: flex;justify-content: space-between")
                                        span
                                            span {{ item.typeName }}
                                            span(v-if="item.type==='VIP'") {{ item.describes?`(${item.describes}折)`:''}}
                                            span(v-if="item.type==='POINT'") {{item.describes?`(${item.describes}积分)`:''}}
                                        span {{ !item.value || item.value == 0 ? '--' : `-${item.value}` }}
                                div(v-else) --
                        el-table-column(align="center",prop="totalDiscount",label="优惠合计(元)")
                            template(slot-scope="scope")
                                span {{ !scope.row.totalDiscount || scope.row.totalDiscount == 0 ? '-0.00' : `-${scope.row.totalDiscount}` }}
                        el-table-column(align="right",prop="paymentPrice",label="应付金额(元)")
                            template(slot-scope="scope")
                                span(style="color:#F5222D") {{ scope.row.paymentPrice || '0.00' }}
            .ordercreater-info.info
                .info-header 下单人信息
                .info-table
                    el-table(:data="ordercreaterTableData",border)
                        el-table-column(align="center",prop="nickName",label="下单人")
                        el-table-column(align="center",prop="phone",label="联系电话")
                        el-table-column(align="center",prop="remark",label="备注")
                            template(slot-scope="scope")
                                span {{ scope.row.remark || '--' }}
            .ordercreater-info.info(v-if="isPhysicalMail")
                .info-header 收货人信息
                .info-table
                    el-table(:data="[orderDetail]",border)
                        el-table-column(align="center",prop="consignee",label="收货人")
                        el-table-column(align="center",prop="consigneePhone",label="联系电话")
                        el-table-column(align="center",prop="consigneeAddress",label="收货地址")
            .ordercreater-info.info(v-if="isPhysicalMail")
                .info-header
                    span 物流信息
                    span(v-if="isUpdateTracking" @click="updateExpress('EDIT')")
                        svg-icon.icon-edit(icon-class="edit")
                        span.link-text 修改物流
                .info-table
                    el-table(:data="[orderDetail]",border)
                        el-table-column(align="center",label="发货门店")
                            template(slot-scope="scope")
                                span {{ scope.row.shopInfo ? scope.row.shopInfo.shopName || '--' : '--' }}
                        el-table-column(align="center",prop="deliveryWay",label="配送方式")
                            template(slot-scope="scope")
                                span {{ scope.row.deliveryWay | fieldVaild }}
                                <el-button style="margin-left: 8px" type="text" v-if="orderDetail.trackingNumber" @click="toKuaiDi">查看</el-button>
                        el-table-column(align="center",prop="trackingNumber",label="物流单号")
                            template(slot-scope="scope")
                                span {{ scope.row.trackingNumber | fieldVaild }}
                        el-table-column(align="center",prop="expressCompany",label="物流公司")
                            template(slot-scope="scope")
                                span {{ scope.row.expressCompany | fieldVaild }}
                        el-table-column(align="center",prop="deliveryTime",label="发货时间")
                            template(slot-scope="scope")
                                span {{ scope.row.deliveryTime | dateFormat }}
                        el-table-column(align="center",prop="deliveryUser",label="操作人")
                            template(slot-scope="scope")
                                span {{ scope.row.deliveryUser | fieldVaild }}
            .ordercreater-info.info(v-if="orderDetail.goodsType === 'PHYSICAL_GOODS' && orderDetail.deliveryWayKey === 'PICK_UP_STORE'")
                .info-header 提货信息
                .info-table
                    el-table(:data="[orderDetail]",border)
                        el-table-column(align="center",prop="shopInfo",label="提货门店")
                            template(slot-scope="scope")
                                span {{ scope.row.shopInfo ? scope.row.shopInfo.shopName || '--' : '--' }}
                        el-table-column(align="center",prop="deliveryWay",label="配送方式")
            .ordercreater-info.info(v-if="orderDetail.goodsType === 'ELECTRONIC_COUPON'")
                .info-header 电子券兑换信息
                .info-table
                    el-table(:data="[orderDetail]",border)
                        el-table-column(align="center",prop="exchange",label="兑换状态")
                            template(slot-scope="scope")
                                span {{ scope.row.exchange === null ? '--' : (scope.row.exchange ? '已兑换' : '未兑换')}}
                        el-table-column(align="center",prop="couponNo",label="兑换券码")
                            template(slot-scope="scope")
                                <el-button v-if="scope.row.couponNo" type="text" @click="toCouponVerify(scope.row.couponNo)">{{ scope.row.couponNo }}</el-button>
                                span(v-else) --
            .ordercreater-info.info(v-if="orderDetail.goodsType === 'SERVICE_PACK'")
                .info-header 销售信息
                .info-table 销售门店：{{ orderDetail.shopInfo ? orderDetail.shopInfo.shopName || '--' : '--'}}
            //- 底部操作按钮
            div.bottom-btns-container(v-if="['TO_BE_DELIVERED', 'IN_DISTRIBUTION'].includes(orderDetail.status)")
                el-button(
                    v-if="orderDetail.status === 'TO_BE_DELIVERED'"
                    :disabled="!getAuthority('OrderManage', 'OrderManageUpdate')",
                    @click="updateExpress()",
                ) 确认发货
                el-button(
                    v-if="orderDetail.status === 'IN_DISTRIBUTION' && userInfo.mode === 3"
                    :disabled="!getAuthority('OrderManage', 'OrderManageUpdate')",
                    @click="handleDistribution",
                ) 配货完成
        div(
            v-show="activeName === 'history'"
            v-loading="hisLoading"
            class="order-detail-history content-common-margin"
        )
            el-table.table(
                border
                :header-cell-style="{'background': '#F9F9F9','padding': '3px 0'}"
                :data="historyData"
            )
                el-table-column(
                    align="center"
                    label="操作类型"
                    prop="operate"
                )
                el-table-column(
                    align="center"
                    label="操作详情"
                    prop="content"
                )
                el-table-column(
                    align="center"
                    label="操作人"
                    prop="operateName"
                )
                el-table-column(
                    align="center"
                    label="操作时间"
                    prop="operateTime"
                )
                    template(
                        slot-scope="scope"
                    )
                        span {{ scope.row.operateTime | dateFormat }}
            el-pagination.pagination(
                layout="sizes, prev, pager, next, jumper"
                :total="historyTotal"
                :page-sizes="[10, 30, 50]"
                :page-size="pageSize"
                :current-page.sync="pageNum"
                @current-change="currentChangeHandle"
                @size-change="sizeChangeHandle"
            )
        //- 确认发货弹框
        confirm-deliver-dialog(
            v-if="confirmDeliverDialog.show"
            :dialogData="confirmDeliverDialog"
            @refresh="()=> getOrderDetail(this.$route.query.id)"
        )
        //- 配货完成
        CompleteDistribution(
            ref="completeDistribution"
            :showConfirm="showConfirm"
            :currentOrder="orderDetail"
            @refresh="()=> {getOrderDetail(this.$route.query.id); showConfirm=false}"
            @cancel="() => showConfirm=false"
        )
</template>
<script>
import dayjs from 'dayjs';
import cloneDeep from 'lodash/cloneDeep';
import { mapGetters, mapState } from 'vuex';
import HeaderTitle from '@/components/HeaderTitle.vue';
import CountTabs from '@/components/CountTabs.vue';
import { orderApis } from '@/api';
import oss from '@/utils/oss';
import ConfirmDeliverDialog from '../home/dialogs/ConfirmDeliver.vue';
import { goodsTypeObj } from '@/enum/common';
import CompleteDistribution from '../home/dialogs/CompleteDistribution.vue';
import { pageRefresh } from '@/mixins';

export default {
    name: 'OrderDetail',
    components: {
        HeaderTitle, CountTabs, ConfirmDeliverDialog, CompleteDistribution,
    },
    mixins: [
        pageRefresh(
            // 从以下页面进入需要刷新
            [
                'OrderManageIndex',
            ],
            // 用于刷新的回调方法名, 会接收到路由参数from
            'refreshPage',
        ),
    ],
    data() {
        return {
            oss,
            goodsTypeObj,
            activeName: 'detail',
            tabOptions: [
                {
                    label: '订单详情',
                    name: 'detail',
                },
                {
                    label: '操作记录',
                    name: 'history',
                },
            ],
            loading: false,
            orderDetail: {},
            statusDesc: '',
            status: '',
            baseTableData: [],
            gooodsTableData: [],
            payTableData: [],
            ordercreaterTableData: [],
            historyData: [],
            historyTotal: 0,
            hisLoading: true,
            pageNum: 1,
            pageSize: 10,
            showConfirm: false,
            confirmDeliverDialog: {
                title: '确认发货',
                show: false,
                orderData: {},
            },
        };
    },

    created() {
        const orderId = this.$route.query.id;
        this.getOrderDetail(orderId);
    },

    computed: {
        ...mapGetters('user', ['getAuthority']),
        ...mapState('user', ['userInfo']),
        isPhysicalMail() {
            return this.orderDetail.goodsType === 'PHYSICAL_GOODS' && this.orderDetail.deliveryWayKey === 'EXPRESS';
        },
        // 是否可修改物流
        isUpdateTracking() {
            const hours = dayjs().diff(dayjs(this.orderDetail.deliveryTime), 'hour');
            return this.orderDetail.trackingNumber && hours <= 72;
        },
    },
    watch: {
        activeName(val) {
            if (val === 'history') {
                this.getHistory();
            }
        },
    },
    methods: {
        refreshPage() {
            this.activeName = 'detail';
            this.historyData = [];
            this.historyTotal = 0;
            this.getOrderDetail(this.$route.query.id);
        },
        currentChangeHandle(pageNum) {
            this.pageNum = pageNum;
            this.getHistory();
        },
        sizeChangeHandle(pageSize) {
            this.pageSize = pageSize;
            this.pageNum = 1;
            this.getHistory();
        },
        // 获取线索操作记录
        async getHistory() {
            this.hisLoading = true;
            await orderApis.getHistory({
                id: this.$route.query.id,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            })
                .then(({ data }) => {
                    if (data) {
                        this.historyData = data.list;
                        this.historyTotal = data.total;
                    }
                })
                .catch((error) => {
                    this.historyData = [];
                    this.historyTotal = 0;
                    throw new Error(error);
                })
                .finally(() => {
                    this.hisLoading = false;
                });
        },
        // 获取商品详情
        getOrderDetail(id) {
            this.loading = true;
            orderApis.getOrderById(id)
                .then(({ data }) => {
                    this.orderDetail = cloneDeep(data);
                    const { status, operationType } = this.orderDetail;
                    if (status === 'CANCELLED' && operationType === 'SYSTEM') {
                        this.statusDesc = '已取消（支付超时）';
                    } else if (status === 'CANCELLED' && operationType === 'USER') {
                        this.statusDesc = '已取消（买家取消）';
                    } else if (status === 'COMPLETED' && operationType === 'SYSTEM') {
                        this.statusDesc = '已完成（系统自动完成）';
                    } else {
                        this.statusDesc = data.statusDesc;
                    }
                    this.status = data.status;
                    this.transBaseInfo(data);
                    this.transGoodsInfo(data);
                    this.transPayInfo(data);
                    this.transCreaterInfo(data);
                })
                .catch(() => {

                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // 转换基本信息
        transBaseInfo(res) {
            const {
                orderNo, paymentWay, appType, orderType, deliveryWay, goodsType, vin,
            } = res;
            this.baseTableData = [
                {
                    orderNo,
                    paymentWay,
                    appType,
                    orderType,
                    vin: vin || '--',
                    // shopInfo: `${res.shopInfo.shopName},${res.shopInfo.shopId}`,
                    nickName: res.userInfo.nickName,
                    nickPhone: res.userInfo.phone,
                    deliveryWay: goodsType === 'ELECTRONIC_COUPON' ? '虚拟发货' : deliveryWay,
                },
            ];
        },

        // 转换商品信息
        transGoodsInfo(res) {
            this.gooodsTableData = res.orderItems;
            const total = res.orderItems.reduce((acc, cur) => acc + cur.total * 1, 0);
            const totalColumn = { total: total.toFixed(2) };
            this.gooodsTableData.push(totalColumn);
        },
        // 转换费用信息
        transPayInfo(res) {
            const {
                salesPrice, totalAmount, paymentPointsPrice, paymentPoints, paymentPrice, freightPrice, discount, totalDiscount,
            } = res;
            this.payTableData = [
                {
                    salesPrice,
                    totalAmount,
                    paymentPointsPrice,
                    paymentPoints,
                    paymentPrice,
                    freightPrice,
                    discount,
                    totalDiscount,
                },
            ];
        },
        // 转换下单人信息
        transCreaterInfo(res) {
            const { remark } = res;
            this.ordercreaterTableData = [
                {
                    remark: remark || '--',
                    nickName: res.goodsType === 'SERVICE_PACK' ? res.operatorInfo.nickName || '--' : res.userInfo.nickName || '--',
                    phone: res.goodsType === 'SERVICE_PACK' ? res.operatorInfo.phone || '--' : res.userInfo.phone || '--',
                },
            ];
        },
        toKuaiDi() {
            window.open('https://www.kuaidi100.com/', '_blank');
        },
        updateExpress(type) {
            this.confirmDeliverDialog.orderData = this.orderDetail || {};
            this.confirmDeliverDialog.show = true;
            this.confirmDeliverDialog.title = type ? '修改发货' : '确认发货';
        },
        // 配货完成
        async handleDistribution() {
            this.showConfirm = true;
            this.$refs.completeDistribution.$refs.confirmDialog.dialogVisible = true;
        },
        toCouponVerify(couponNo) {
            this.$router.push({
                name: 'CouponVerifyIndex',
                params: {
                    couponNo,
                },
                query: {
                    navType: 'MarketingManage',
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
    .order-detail {
        .text-desc {
            margin-top: 10px;
            section {
                line-height: 20px;
            }
            text-align: center;
        }
        min-height: 600px;

        .blue {
            cursor: pointer;
            color: #4877F4;
        }
        .empty-info {
            padding: 20px 0 20px;
            text-align: center;
            color: #999999;
        }
        &-tab {
            .count-tabs {
                display: flex;
                justify-content: center;
            }
        }
        .detail-tab-container {
            padding-bottom: 70px;
        }
        &-history {
            @include bg_color(color_base_white);
            padding: 20px;
            .pagination {
                display: flex;
                justify-content: center;
                margin-top: 28px;
            }
        }
        .bottom-btns-container {
            button {
                width:120px;
                height:36px;
                border-radius:18px;
            }
        }
    }
    .infos {
        margin-top: 50px;
        padding-bottom: 65px;
        .info-status {
            padding: 10px 20px;
            color: #333333;
            font-weight: bold;
        }
        .times {
            font-size: 12px;
            color: rgba(0,0,0,0.45);
            line-height: 20px;
            padding: 0 0 12px 20px;
            .time {
                margin-right: 43px;
            }
        }
        .info {
            background: #ffffff;
            .info-header{
                padding: 10px 20px;
                height: 40px;
                box-shadow: 0px 1px 0px 0px #F5F5F5;
                color: #333333;
                font-weight: bold;
                display: flex;
                align-items: center;
                border-bottom: 1px solid;
                border-color: #eef2f8;
                .icon-edit {
                    width: 18px;
                    height: 18px;
                    margin: 0 8px;
                    position: relative;
                    top: 2px;
                    cursor: pointer;
                }
                .link-text {
                    color: #2970FF;
                    line-height: 22px;
                    cursor: pointer;
                }
            }
            .info-table {
                padding: 20px;
            }
            margin-top: 10px;
        }
        .info-base {
            margin-top: 0;
        }
    }
    .img-contaner {
        .pic-main{
            height: 100px;
            width: 100px;
            margin: 8px 10px;
        }
    }
</style>

<style lang="scss">
.infos {
    .is-right {
        padding-right: 10px !important;
    }
}
.el-table__header{
    th{
        padding: 0;
        background-color: #F9F9F9 !important;
        .cell {
            font-size: 12px !important;
        }
    }
}
.info-goods{
    .el-table__body{
        tbody{
            > :last-child{
                background: #FFFBE6 !important;
                height: 40px !important;
                font-size: 14px;
                font-weight: 500;
            }
        }
    }
}
        .info-TO_BE_RECEIVED {
            background: #F0F7FF;
        }
        .info-COMPLETED {
            background: #F6FFED;
        }
.IN_DISTRIBUTION {
    background-color: #FFFBE6;
    .status-desc {
        color: #FAAD14;
    }
}
.TO_BE_RECEIVED,.TO_BE_DELIVERED,.PENDING_PAY {
    background-color: #F0F7FF;
    .status-desc {
        color: #2970FF;
    }
}
.COMPLETED {
    background-color: #F6FFED;
    .status-desc {
        color:#52C41A;
    }
}
.CANCELLED {
    background-color: #F5F5F5;
    .status-desc {
        color:#8C8C8C;
    }
}

</style>
